module.exports = __webpack_public_path__ + "assets/mobile_back_white-5f20ae.svg";